//
// MissingValueBehavior.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var MissingValueBehavior = {
    DEFAULT:0,
    INCLUDE:1
};
export default MissingValueBehavior;
